import React from 'react';
import { Clock } from 'lucide-react';
import { motion } from 'framer-motion';
interface InactivityTimerProps {
  remainingTime: number;
}
export function InactivityTimer({
  remainingTime
}: InactivityTimerProps) {
  const seconds = Math.ceil(remainingTime / 1000);
  const isWarning = seconds <= 15;
  const isCritical = seconds <= 10;
  return <div className={`flex items-center gap-2 px-3 py-1.5 rounded-lg border transition-all duration-300 ${isCritical ? 'bg-red-500/10 border-red-500/20' : isWarning ? 'bg-amber-500/10 border-amber-500/20' : 'bg-navy-800/60 border-white/10'}`} data-id="element-440">
      <motion.div animate={isCritical ? {
      scale: [1, 1.2, 1],
      rotate: [0, -10, 10, -10, 0]
    } : {}} transition={{
      duration: 0.5,
      repeat: isCritical ? Infinity : 0,
      repeatDelay: 0.5
    }} data-id="element-441">
        <Clock size={14} className={isCritical ? 'text-red-400' : isWarning ? 'text-amber-400' : 'text-slate-400'} data-id="element-442" />
      </motion.div>
      <div className="flex items-baseline gap-1" data-id="element-443">
        <span className={`text-xs font-medium ${isCritical ? 'text-red-400' : isWarning ? 'text-amber-400' : 'text-slate-400'}`} data-id="element-444">
          Auto-lock:
        </span>
        <span className={`text-sm font-bold tabular-nums ${isCritical ? 'text-red-300' : isWarning ? 'text-amber-300' : 'text-slate-200'}`} data-id="element-445">
          {seconds}s
        </span>
      </div>
    </div>;
}